import { Button, PageHeader } from 'components';
import { Form, Row, Col } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined, EyeOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import { useTranslation } from 'react-i18next';
import FileSection from './formSections/file';
import LastSection from './formSections/last';
import FormHelper from 'helpers/FormHelper';
import useExtrastockOffers from '../useExtrastockOffers';
import { Link, useLocation } from 'react-router-dom';
import UIHelper from '../../../../../helpers/UIHelper';
import NotificationFormForEdit from '../../../../../components/modules/notificationFormForEdit';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const {
    form,
    shops,
    inactiveShops,
    contractType,
    handleCreateOrUpdate,
    onChangeExtrastockGetFields,
    extrastocks,
    singleItem,
    handleDeleteFile,
    updateInProcess,
    handleApprove,
  } = useExtrastockOffers(false, !isNew);
  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = isNew
    ? t('RICHIESTA EXTRASTOCK')
    : t('MODIFICA EXTRASTOCK');
  const isApproveOnly = singleItem.can_approve && !singleItem.can_update;

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            company_id: '',
            contract_type: '',
            applicant: '',
            message: '',
            rent_file: [],
            end_rent_file: [],
            hot_file_signed: [],
            contract_file: [],
            legal_name: '',
            offer_date: '',
            waiting_list: false,
            price: 0.0,
            consumption_price: 0.0,
            comment: '',
            date_from: '',
            date_to: '',
            extrastock_id: '',
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
          onFieldsChange={(changedFields) => {
            onChangeExtrastockGetFields(changedFields);
            FormHelper.resetFormsFieldErrors(form)(changedFields);
          }}
        >
          <InfoSection
            isView={isApproveOnly}
            shops={shops}
            inactiveShops={inactiveShops}
            contractType={contractType}
            extrastocks={extrastocks}
          />
          <FileSection
            isView={isApproveOnly}
            singleItem={singleItem}
            handleDeleteFile={handleDeleteFile}
            updateInProcess={updateInProcess}
          />
          <LastSection isView={isApproveOnly} extrastocks={extrastocks} />
        </Form>
        {!isApproveOnly && (
          <Row gutter={16}>
            <Col>
              <Button
                onClick={onClickSave}
                width={'150px'}
                big
                icon={<CheckOutlined />}
              >
                {t('Invia')}
              </Button>
            </Col>
          </Row>
        )}
        {!isNew && (
          <NotificationFormForEdit
            loading={updateInProcess}
            handleOnFinish={handleApprove}
            showApprove={singleItem?.can_approve}
            showReject={false}
            showToAdim={false}
            showRefuse={true}
            showInProgress={singleItem?.can_in_progress}
            showConfirmTheRequest={singleItem?.can_confirm_the_request}
            approveKey={'approve'}
            rejectKey={'refuse'}
            inProgressKey={'in_progress'}
            confirmTheRequestKey={'confirm_the_request'}
          />
        )}
      </div>
    </div>
  );
};

export default Edit;
